import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
// import { UserContext } from "../../App";
// import PaymentRequestModal from "../../containers/shared/PaymentRequestModal";
import NormalButton from "../shared/NormalButton";
import moment from "moment";
import apiClient from "../utils/apiClient";
import { getPaymentRequestStatus } from "../utils/styles";

export default function PaymentRequestTable({ paymentRequests,currentPage=false,pageSize=0 }) {

    const navigate = useNavigate();

    // const { PaymentRequestCategoriesOptions } = useContext(UserContext);

    const [selectedPaymentRequest, setSelectedPaymentRequest] = useState();
    const [showPaymentRequestDetails, setShowPaymentRequestDetails] = useState(false);


    const handleClickPaymentRequestRow = (PaymentRequest) => {
        
    }

    const handleClickShowPopup = (PaymentRequest) => {
        // setSelectedPaymentRequest(PaymentRequest);
        // setShowPaymentRequestDetails(true);
    }

    const handleCloseModal = () => {
        setShowPaymentRequestDetails(false);
    }

    const paymentRequestsStatus = (paymentRequests) => {
        if(paymentRequests.quantity - paymentRequests?.issuedQuantity <= paymentRequests?.reorderPoint) {
            return <span className="text-danger">تحتاج لاعادة طلب</span>;
        }
        if(paymentRequests?.issuedQuantity / paymentRequests?.quantity > 0.75) {
            return <span className="text-warning">يقترب من النفاذ</span>;
        } else {
            return <span className="text-success">متوفر</span>;
        }
    } 

    const handleShowPaymentRequestDetails = (paymentRequests) => {
        setSelectedPaymentRequest(paymentRequests);
        setShowPaymentRequestDetails(true);
    }

    const handleClickEditPaymentRequest = () => {
        navigate(`/ar/paymentRequests/edit/${selectedPaymentRequest?._id}`);
    }

    const getUserRoleName = (role) => {
        switch(role) {
            case 'ADMINISTRATOR':
                return 'المديرين';
            case 'EMPLOYEE':
                return 'الموظفين';
            case 'BENEFICIARY':
                return 'المستفيدين';
            default:
                return '';
        }
    }


    const getRepateLabel = (frequency) => {
        switch(frequency) {
            case 'weekly':
                return 'اسبوعيا';
            case 'monthly':
                return 'شهريا';
            case 'quarterly':
                return 'ربع سنوي';
            case 'semi-annually':
                return 'نصف سنوي';
            case 'yearly':
                return 'سنويا';
            default:
                return '';
        }
    }

    // console.log(paymentRequests);

    

    const handleClickPayPaymentRequest = async (id) => {
        let callback;
        callback =  window?.location?.href;
        try {
        const response = await apiClient.post(`/b-payment-requests/pay`,{requestId: id,frontEndCallback:callback});
        if(response?.data) {
          window.location.href = response?.data?.formUrl;
          return false;
        } else {
        }
        } catch(err) {}
    }


    return (
        <>
        <div className="pb-[30px]">
            <table className="w-full mt-[30px] max-w-[100%]" dir="rtl">
                <thead>
                <tr className="border-b-[2px] border-b-grey-50">
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tr-[8px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">#</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">عنوان أمر الدفع</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">القيمة</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">تاريخ الاستحقاق</th>
                    <th className="bg-darkBlue text-white leading-[56px] px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100 text-center">الحالة</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">التكرار</th>
                    {/* <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">عدد المتاخرين</th> */}
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tl-[8px] px-[15px] text-[16px] font-[500px] min-w-[200px] text-center">حالة الدفع</th>
                </tr>
                </thead>
                <tbody>
                {paymentRequests.map((PaymentRequest, index) => {;
                    return (
                    <tr key={`paymentRequests-${index}`} className={`${index !== paymentRequests?.length-1 && 'border-b-[1px] border-b-grey-200'}`}>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap w-[52px] cursor-pointer ${index === paymentRequests?.length-1 && 'rounded-br-[8px]'}`} onClick={()=>handleClickPaymentRequestRow(PaymentRequest)}>{currentPage ? ((currentPage-1)*pageSize) + (index+1) : index+1}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer`} onClick={()=>handleClickPaymentRequestRow(PaymentRequest)}>{PaymentRequest?.title}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer relative`} onClick={()=>handleClickPaymentRequestRow(PaymentRequest)}>{PaymentRequest?.amount}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickPaymentRequestRow(PaymentRequest)}>{moment(PaymentRequest?.dueDate).format('DD MMM YYYY')}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer text-center`} onClick={()=>handleClickPaymentRequestRow(PaymentRequest)}>{getPaymentRequestStatus(PaymentRequest?.status)}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap ${index === paymentRequests?.length-1 && 'rounded-bl-[8px]'}`} onClick={()=>handleClickPaymentRequestRow(PaymentRequest)}>{PaymentRequest?.isRecurring ? ' يكرر '+getRepateLabel(PaymentRequest?.recurrence?.frequency) : 'لا يكرر'}</td>

                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-center whitespace-nowrap w-[48px] ${index === paymentRequests?.length-1 && 'rounded-bl-[8px]'} ${PaymentRequest?.status === 'pending' ? 'opacity-100' : 'opacity-50'}`} onClick={()=> PaymentRequest?.status ? handleClickPayPaymentRequest(PaymentRequest?._id) : ''}><div className="text-darkBlue font-[700] text-[20px] cursor-pointer select-none" onClick={()=>handleShowPaymentRequestDetails(PaymentRequest)}> الدفع <span className="w-[16px] h-[16px] leading-[16px] inline-block align-middle" style={{background: "url('/assets/images/arrow-left-ben.svg') center no-repeat"}}></span></div></td>
                    </tr>
                    )
                })}
                </tbody>
            </table> 
        </div>
        

          {/* { showPaymentRequestDetails && <PaymentRequestModal handleCloseModal={handleCloseModal}>
            <div className="">
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] px-[16px]">
                    <span className="text-[12px] text-grey-900 font-[600]">عنوان التنبيه:</span> {selectedPaymentRequest?.title}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">رسالة التنبية:</span> {selectedPaymentRequest?.body}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">الفئة المستهدفة:</span> {getUserRoleName(selectedPaymentRequest?.roles[0])}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">عدد المنبهين:</span> {selectedPaymentRequest?.users?.length === 0 ? 'كل الفئة مستهدفة' : selectedPaymentRequest?.users?.length}
                </div>
                {selectedPaymentRequest?.users?.length > 0 && <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">اسماء المنبهين:</span> {selectedPaymentRequest?.users?.map(user=>user?.name).join(', ')}
                </div>}
                <div className="text-end p-[16px] !pt-[0]">
                    <div className="text-grey-400 text-[18px] font-[600] inline-block cursor-pointer select-none me-[15px]" onClick={handleCloseModal}>إلغاء</div>
                </div>
            </div>
        </PaymentRequestModal> } */}

        </>
    )
}

